import { UseQueryExecute, UseQueryArgs, useQuery, UseQueryState } from 'urql';

import { CartQueryVariables } from '__generated__/graphql';
import { SIMPLE_CART_QUERY } from 'gql/queries/cart';
import { SimpleCart } from 'types/cart';

import { useIsServer } from './useIsServer';

export type UseCartResult = {
  cart?: SimpleCart;
  cartResult: UseQueryState<{ activeCart: SimpleCart }>;
  refetch: UseQueryExecute;
};

export const useSimpleCart = (
  cartQueryOptions: Omit<UseQueryArgs<CartQueryVariables>, 'query'> = {}
): UseCartResult => {
  const isServer = useIsServer();
  const [simpleCart, refetch] = useQuery<
    { activeCart: SimpleCart },
    CartQueryVariables
  >({
    query: SIMPLE_CART_QUERY,
    pause: isServer || (cartQueryOptions.pause ?? false),
  });

  return {
    cart: simpleCart.data?.activeCart,
    cartResult: simpleCart,
    refetch: refetch,
  };
};
